module.exports = __webpack_public_path__ + "static/media/personalAvatar.ae38cd65.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Images/personalAvatar.png
// module id = 916
// module chunks = 0